(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mw-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-card-swatches')) return;

    // Prikkerne er rigtige links. Uden JavaScript navigerer de til PDP'en med
    // farven valgt — det er den fulde, fungerende oplevelse. Herunder bytter
    // vi billedet på stedet i stedet og flytter kortets egne links med over
    // på varianten, så titel og «Vælg variant» peger samme sted som prikken.
    class MwCardSwatches extends HTMLElement {
      connectedCallback() {
        const kort = this.closest('.mw-pcard');
        if (!kort) return;
        this.billede = kort.querySelector('.mw-pcard__img:not(.mw-pcard__img--hover)');
        if (!this.billede) return;

        this.links = [...kort.querySelectorAll('.mw-pcard__link, .mw-pcard__qbtn')].filter((a) => a.tagName === 'A');

        this.addEventListener('click', (e) => {
          const prik = e.target.closest('.mw-pcard__swatch');
          if (!prik || !prik.dataset.mwSwImg) return;
          e.preventDefault();
          this.skift(prik);
        });
      }

      // To ting adskiller et pænt farveskift fra et hårdt:
      //
      //   decode() FØR byttet. Sætter man bare src, tømmes billedet med det
      //   samme og fyldes igen, når nettet svarer — et hvidt glimt midt i
      //   kortet. Vi henter og afkoder det nye billede først, så byttet sker
      //   på ét billede, hvor begge er klar.
      //
      //   View Transition til selve overgangen. Mediefladen har allerede et
      //   view-transition-name (den bruges til at morfe kort → produktside),
      //   så browseren kan krydsfade den gratis. Falder tilbage til et rent
      //   bytte, hvis API'et mangler eller brugeren har bedt om mindre
      //   bevægelse.
      async skift(prik) {
        const url = prik.dataset.mwSwImg;
        const seq = (this._swSeq = (this._swSeq || 0) + 1);
        try {
          const forud = new Image();
          forud.src = url;
          if (forud.decode) await forud.decode();
        } catch (e) {
          // Et billede der ikke kan afkodes, skal ikke spærre for valget —
          // <img> prøver selv igen, og prikken skal stadig markeres.
        }
        if (seq !== this._swSeq) return;

        const roligt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !roligt) {
          document.startViewTransition(() => {
            if (seq !== this._swSeq) return;
            this.vaelg(prik);
          });
        } else {
          this.vaelg(prik);
        }
      }

      vaelg(prik) {
        for (const s of this.querySelectorAll('.mw-pcard__swatch')) {
          const valgt = s === prik;
          s.classList.toggle('is-valgt', valgt);
          if (valgt) s.setAttribute('aria-current', 'true');
          else s.removeAttribute('aria-current');
        }

        // srcset ryddes FØR src sættes. Bliver den stående, vinder browserens
        // gamle kandidatliste over den nye src, og billedet skifter ikke.
        this.billede.srcset = '';
        this.billede.sizes = '';
        this.billede.src = prik.dataset.mwSwImg;
        if (prik.dataset.mwSwAlt) this.billede.alt = prik.dataset.mwSwAlt;

        const href = prik.getAttribute('href');
        for (const a of this.links) a.setAttribute('href', href);
      }
    }

    customElements.define('mw-card-swatches', MwCardSwatches);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mwChat) return;
    window.__mwChat = true;
    const widget = () => {
      const el = document.querySelector('shopify-chat');
      return el && typeof el.show === 'function' ? el : null;
    };
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-mw-chat]');
      if (!t) return;
      // Inbox slået til? Embed-data-scriptet er i HTML'en fra første byte,
      // selve <shopify-chat> indsættes først sekunder senere.
      const enabled = document.querySelector('shopify-chat, #shopify-chat-app-embed-data');
      if (!enabled) return; // Inbox ikke slået til: normal navigation til href
      e.preventDefault();
      const w = widget();
      if (w) { w.show(); return; }
      // Vent på at widgeten indsættes og opgraderes; fald tilbage til href efter 6 s.
      // Klikket skal kvittere med det samme. Før kunne knappen stå helt død
      // i seks sekunder uden et eneste tegn på liv — og seks sekunder uden
      // svar læses som «virker ikke», ikke som «henter».
      let done = false;
      t.setAttribute('aria-busy', 'true');
      const oprydning = () => { t.removeAttribute('aria-busy'); };
      const go = () => {
        if (done) return;
        done = true;
        clearInterval(poll);
        oprydning();
        const ww = widget();
        if (ww) ww.show();
        else if (t.href) window.location.assign(t.href);
      };
      const poll = setInterval(() => { if (widget()) go(); }, 150);
      // 2,5 s frem for 6: efter to et halvt sekund er kontaktsiden et bedre
      // svar end fortsat venten.
      setTimeout(go, 2500);
    });
    // Marker dokumentet når chat er tilgængelig (CSS kan vise "online"-hint)
    const mark = () => { if (widget()) document.documentElement.classList.add('mw-chat-ready'); };
    mark();
    setTimeout(mark, 3000);
    setTimeout(mark, 8000);

    /* ---- SAFE-AREA-CONTROLLER (eneste ejer af --shopify-agent-activator-offset)
       Aktivatoren må aldrig dække: sticky ATC, cookie-banner eller andre
       bund-fikserede handlinger ([data-mw-chat-avoid]). Ved åben dialog
       (cart/nav/filter/search/lightbox) skjules den, så to flydende handlinger
       aldrig konkurrerer. På smalle skærme viger den for supportens primære
       chatkort ([data-mw-chat-primary]). Event-/observer-drevet — ingen polling. */
    const AVOID = '[data-mw-chat-avoid], #shopify-pc__banner';
    const root = document.documentElement;
    let raf = 0;
    let primaryVisible = false;

    const host = () => document.querySelector('shopify-chat');
    const dialogOpen = () => !!document.querySelector('dialog[open]');
    const visible = (el) => {
      if (!el || el.hidden) return false;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
      const r = el.getBoundingClientRect();
      if (r.height < 2 || r.width < 2) return false;
      // Elementer med eksplicit tilstand (is-visible) afgøres af intentionen,
      // så en igangværende transition ikke giver et forkert øjebliksbillede
      if (el.classList.contains('is-visible')) return true;
      if (el.hasAttribute('data-mw-chat-avoid') && el.className.indexOf('is-visible') === -1 && cs.transform !== 'none' && cs.transitionDuration !== '0s') return false;
      // Kun elementer, der reelt sidder i bunden af viewporten
      return r.bottom >= window.innerHeight - 2 && r.top < window.innerHeight;
    };

    const apply = () => {
      raf = 0;
      let offset = 0;
      document.querySelectorAll(AVOID).forEach((el) => {
        if (!visible(el)) return;
        // Højden (ikke den aktuelle position) — robust under transitions
        offset = Math.max(offset, Math.ceil(el.getBoundingClientRect().height));
      });
      const gap = parseFloat(getComputedStyle(root).getPropertyValue('--mw-chat-gap')) || 12;
      const total = offset > 0 ? offset + gap : 0;
      root.style.setProperty('--mw-chat-offset', total + 'px');
      const h = host();
      if (h) {
        h.style.setProperty('--shopify-agent-activator-offset', total ? total + 'px' : '');

        // VARIABLEN ALENE VIRKER IKKE. Målt på live 2026-08-28: controlleren
        // skrev korrekt 85px (bar 72 + gap 13), og boblen blev liggende —
        // den dækkede 73 % af sticky-«Læg i kurv» ved 390 px og 27 % ved
        // 1280. Widgetten er tredjeparts og adlyder ikke variablen.
        //
        // En transform på host'en flytter den faktisk (målt: 73 % → 0 %).
        // Variablen bliver stående: begynder Shopify at respektere den, gør
        // de to det samme, og transformen kan fjernes uden at noget flytter.
        h.style.transform = total ? 'translateY(-' + total + 'px)' : '';
        h.style.transition = 'transform var(--mw-dur-ui, 250ms) var(--mw-ease-out, ease)';
        const narrow = window.innerWidth < 750;
        const hide = dialogOpen() || (narrow && primaryVisible);
        h.style.visibility = hide ? 'hidden' : '';
        h.setAttribute('aria-hidden', hide ? 'true' : 'false');
      }
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(apply); };

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    // Avoid-elementer glider ind/ud (transform-transition): mål igen når de er i ro
    document.addEventListener('transitionend', (e) => { if (e.target.matches && e.target.matches(AVOID)) schedule(); });
    ['mw:drawer:open', 'mw:drawer:close', 'mw:cart:open', 'mw:cart:close', 'mw:cart:updated', 'shopify:section:load', 'mw:pdp:bar']
      .forEach((ev) => document.addEventListener(ev, schedule));

    // Dialoger (open-attribut) + avoid-elementers tilstand (class/hidden/style)
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.attributeName === 'open') { schedule(); return; }
        if (m.target.matches && m.target.matches(AVOID)) { schedule(); return; }
      }
    });
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden', 'style'] });

    // Cookie-banner/avoid-elementer kan ændre højde uden attribut-ændringer
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(schedule);
      const watch = () => document.querySelectorAll(AVOID).forEach((el) => ro.observe(el));
      watch();
      document.addEventListener('shopify:section:load', watch);
      // Banneret indsættes asynkront
      const addMo = new MutationObserver(() => { watch(); schedule(); });
      addMo.observe(document.body, { childList: true });
    }

    // Supportens primære chatkort: når det er synligt på smal skærm, viger aktivatoren
    const primary = document.querySelector('[data-mw-chat-primary]');
    if (primary && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        primaryVisible = entries.some((e) => e.isIntersecting && e.intersectionRatio >= 0.6);
        schedule();
      }, { threshold: [0, 0.6] }).observe(primary);
    }

    // Første kørsel + når widgeten indsættes (sekunder efter load)
    schedule();
    const hostMo = new MutationObserver(() => { if (host()) { schedule(); hostMo.disconnect(); } });
    hostMo.observe(document.body, { childList: true });
    setTimeout(schedule, 3000);
    setTimeout(schedule, 8000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mwDeliv) return;
    window.__mwDeliv = true;
    const DAYS = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
    const MONTHS = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;

    // Weekender blev sprunget over, helligdage ikke. En ordre d. 23. december
    // fik derfor lovet levering 2. juledag. Fragtmændene kører ikke de dage,
    // uanset hvad vi skriver — og et løfte om en pakke juleaftensdag er den
    // slags, en kunde husker.
    //
    // Påsken flytter sig, så den skal regnes ud (Meeus/Butcher). Påskedag og
    // pinsedag er søndage og fanges allerede af weekend-tjekket.
    const paaskedag = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    };
    const noegle = (d) => d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    const skub = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
    const HELLIG = new Set();
    {
      const iaar = new Date().getFullYear();
      for (const y of [iaar, iaar + 1]) {
        const pa = paaskedag(y);
        for (const d of [
          new Date(y, 0, 1),      // nytårsdag
          skub(pa, -3),           // skærtorsdag
          skub(pa, -2),           // langfredag
          skub(pa, 1),            // 2. påskedag
          skub(pa, 39),           // Kristi himmelfartsdag
          skub(pa, 50),           // 2. pinsedag
          new Date(y, 11, 24),    // juleaftensdag — fragtmændene kører ikke
          new Date(y, 11, 25),    // juledag
          new Date(y, 11, 26)     // 2. juledag
        ]) HELLIG.add(noegle(d));
      }
    }
    // En helligdag er lukket, også hvis butikken ellers afsender i weekenden.
    const erLukket = (d, weekendOk) => HELLIG.has(noegle(d)) || (!weekendOk && isWeekend(d));

    const addBiz = (d, n, weekendOk) => {
      const x = new Date(d);
      while (n > 0) { x.setDate(x.getDate() + 1); if (!erLukket(x, weekendOk)) n--; }
      return x;
    };
    const fmt = (d) => DAYS[d.getDay()] + ' ' + d.getDate() + '. ' + MONTHS[d.getMonth()];
    const rel = (d, now) => {
      const a = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const b = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      const diff = Math.round((b - a) / 86400000);
      if (diff === 1) return 'i morgen';
      if (diff === 2) return 'i overmorgen';
      return fmt(d);
    };

    const render = (el) => {
      const now = new Date();
      const cutoff = Number(el.dataset.cutoff) || 14;
      const min = Number(el.dataset.min) || 0;
      const max = Number(el.dataset.max) || 0;
      const weekendOk = el.dataset.weekend === 'true';
      // Afsendelsesdag: i dag hvis før deadline på en afsendelsesdag, ellers næste
      let ship = new Date(now);
      const beforeCutoff = now.getHours() < cutoff;
      if (!(beforeCutoff && !erLukket(ship, weekendOk))) ship = addBiz(ship, 1, weekendOk);
      const first = addBiz(ship, min, false);
      const last = addBiz(ship, max, false);
      const title = el.querySelector('[data-mw-deliv-title]');
      const sub = el.querySelector('[data-mw-deliv-sub]');
      // Et interval skal have samme slags ender. Linjen sagde før «Levering i
      // overmorgen – torsdag 27. aug.» — en relativ og en absolut dato i samme
      // sætning, som både blev lang og læste skævt. Én dag beholder det varme
      // «i overmorgen»; et interval får to korte datoer.
      if (min === max) {
        title.textContent = 'Levering ' + rel(first, now);
      } else if (first.getMonth() === last.getMonth()) {
        title.textContent = 'Levering ' + first.getDate() + '.–' + last.getDate() + '. ' + MONTHS[last.getMonth()];
      } else {
        title.textContent = 'Levering ' + first.getDate() + '. ' + MONTHS[first.getMonth()] + ' – ' + last.getDate() + '. ' + MONTHS[last.getMonth()];
      }
      const sameDay = ship.toDateString() === now.toDateString();
      if (sameDay) {
        const msLeft = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff) - now;
        const h = Math.floor(msLeft / 3600000), m = Math.floor((msLeft % 3600000) / 60000);
        // ET FAST KLOKKESLÆT, IKKE ET FALDENDE UR.
        //
        // Her stod «bestil inden 5 t 1 min», og tallet talte ned mens man
        // læste. Ved siden af pulserer leveringsprikken i vejrtrækningstakt.
        // Sammen blev de til knaphedspres — og «ro før intensitet» er
        // brandets første sætning. Et klokkeslæt siger nøjagtig det samme,
        // er nemmere at handle på, og bliver ikke mere presserende af at
        // man kigger på det.
        //
        // h og m beholdes: de afgør stadig mw-deliv--late under en time.
        const kl = String(cutoff).padStart(2, '0');
        sub.textContent = 'Afsendes i dag \u2014 bestil inden kl.\u00a0' + kl;
        el.classList.toggle('mw-deliv--late', msLeft < 3600000);
      } else {
        sub.textContent = 'Afsendes ' + rel(ship, now);
        el.classList.remove('mw-deliv--late');
      }
    };

    const tick = () => document.querySelectorAll('[data-mw-deliv]').forEach(render);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
    setInterval(tick, 60000);
    document.addEventListener('shopify:section:load', tick);
    // Kurv-draweren genrenderes via Cart API, så dens leveringsdato er urørt
    // indtil næste minut-tick. Uden disse to ville kunden se «Se leveringstid»
    // i op til 60 sekunder præcis dér, hvor datoen betyder mest.
    document.addEventListener('mw:cart:updated', tick);
    document.addEventListener('mw:drawer:open', tick);
    // PDP: skjul ved udsolgt variant
    document.addEventListener('mw:product:variant', (e) => {
      const el = e.target.querySelector('[data-mw-deliv]');
      if (el) el.hidden = !(e.detail && e.detail.variant && e.detail.variant.available);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-delivery-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mwDelivCalc) return;
    window.__mwDelivCalc = true;
    let delivSeq = 0;
    let delivAc = null;

    const kr = (v) => (window.mwMoney ? window.mwMoney(Math.round(Number(v) * 100)) : Number(v).toFixed(2) + ' kr');

    // Fri fragt-grænsen læses fra panelets egen data-attribut, som Liquid
    // fylder fra Temaindstillinger → Handel. Samme kilde som annoncebåndet,
    // footeren og vilkårene: ét tal, ét sted.
    //
    // Den er nødvendig her, fordi Shopifys satse-API kun kan svare på DEN
    // kurv, kunden har lige nu. Den kan ikke sige «hvad ville det koste,
    // hvis du købte for 500» — og at gætte det ville være at opfinde priser.
    // Reglen står derfor som en oplyst regel, ikke som et beregnet tal.
    const GRAENSE = Number(document.querySelector('[data-mw-deliv-graense]')?.dataset.mwDelivGraense || 0);

    // Delegeret, så knapperne kan skiftes ud under fødderne på os uden at
    // lytterne skal bindes igen ved hver gentegning.
    document.addEventListener('click', (e) => {
      const aab = e.target.closest('[data-mw-deliv-open]');
      if (aab) {
        const ud = aab.closest('[data-mw-deliv-result]');
        if (ud && ud.__mwVisDetalje) ud.__mwVisDetalje(Number(aab.dataset.mwDelivOpen));
        return;
      }
      const tb = e.target.closest('[data-mw-deliv-back]');
      if (tb) {
        const ud = (tb.closest('.mw-delivp') || document).querySelector('[data-mw-deliv-result]');
        if (ud && ud.__mwVisOversigt) {
          ud.__mwVisOversigt();
          // Fokus tilbage til det felt, valget udgik fra — ikke til <body>.
          (tb.closest('.mw-delivp') || document).querySelector('[data-mw-deliv-zip]')?.focus({ preventScroll: true });
        }
      }
    });

    // TEGNINGEN. Kaldes to steder: med rigtige satser fra Shopify, når
    // kunden har en kurv — og med butikkens egne satser, når panelet åbner
    // og kurven er tom. Shopify kan kun prissætte den kurv, der findes, men
    // fragtprofilen har én zone (Danmark) og kun betingelser på ordrens
    // beløb — ingen på postnummer. Målt på 1050, 2300, 3790, 5591 og 9990:
    // fuldstændig identiske satser. Prisen kan derfor siges med det samme,
    // og at kræve en vare i kurven først var friktion uden gevinst.
    //
    // Én tegnefunktion, så de to visninger aldrig kan komme til at se
    // forskellige ud.
    const tegn = (ud, satser, sted, panel) => {
      const tilbage = panel.querySelector('[data-mw-deliv-back]');
      const overskrift = panel.querySelector('[data-mw-deliv-heading]');
      const logoer = (() => {
        try { return JSON.parse(ud.getAttribute('data-mw-carriers') || '{}'); } catch (e) { return {}; }
      })();
      const ren = (v) => String(v == null ? '' : v).replace(/[<>&"]/g, '');

      const FRAGTMAEND = [
        { id: 'dao', navn: 'DAO', proev: /\bdao\b/i },
        { id: 'gls', navn: 'GLS', proev: /\bgls\b/i },
        { id: 'postnord', navn: 'PostNord', proev: /post\s*nord/i },
      ];
      const GRUPPER = [
        { id: 'shop', titel: 'Pakkeshop', proev: /pakkeshop|pakkeboks|udleveringssted|shop/i },
        // Længste alternativ FØRST: regex-alternation vælger den første der
        // matcher, og «hjemme» alene efterlod et forældreløst «levering» i
        // rækken, når navnet blev trimmet ned.
        { id: 'hjem', titel: 'Hjemmelevering', proev: /hjemmelevering|privatadresse|hjemme|adresse|home|d(ø|oe)r/i },
      ];

      // delivery_days er [min, max] fra satsens transittid i admin. Er den
      // ikke sat, skriver vi ingenting — hellere tavshed end en opfundet
      // leveringstid.
      const dage = (s) => {
        const d = Array.isArray(s.delivery_days) ? s.delivery_days.filter((n) => Number.isFinite(n)) : [];
        if (!d.length) return '';
        const lav = Math.min.apply(null, d);
        const hoej = Math.max.apply(null, d);
        return lav === hoej ? lav + ' hverdag' + (lav === 1 ? '' : 'e') : lav + '–' + hoej + ' hverdage';
      };

      const maerke = (f) => {
        const url = logoer[f.id];
        return url
          ? '<img class="mw-delivp__logo" src="' + ren(url) + '" alt="' + ren(f.navn) + '" height="24" loading="lazy" decoding="async">'
          : '<span class="mw-delivp__wordmark">' + ren(f.navn) + '</span>';
      };

      const bunker = GRUPPER.map((g) => ({ titel: g.titel, satser: [] }));
      const uklassificerede = [];
      satser.forEach((s) => {
        const navn = String(s.name || s.presentment_name || '');
        const i = GRUPPER.findIndex((g) => g.proev.test(navn));
        if (i > -1) bunker[i].satser.push(s); else uklassificerede.push(s);
      });
      // En sats vi ikke kan placere står som sit eget kort under sit eget
      // navn. Den bliver aldrig skjult, bare fordi mønstret ikke kendte den.
      uklassificerede.forEach((s) => {
        bunker.push({ titel: String(s.name || s.presentment_name || 'Levering'), satser: [s] });
      });

      // ── TO VISNINGER ──
      //
      // Oversigten svarer på «hvad koster det at få den hjem» — ét kort pr.
      // leveringsform, med fragtmændenes navne som tekst. Seks rækker, hvor
      // tre kun adskiller sig ved et logo, er seks beslutninger kunden ikke
      // har: valget er hent selv eller bragt til døren.
      //
      // Detaljen svarer på «hvem kommer med den, og hvad koster hver af
      // dem» — og dét er et rigtigt spørgsmål, når fragtmændene ikke koster
      // det samme. Logoerne hører til her, hvor de er svaret, ikke i
      // oversigten hvor de er pynt.
      //
      // Begge visninger tegnes af de SAMME satser. Der hentes intet igen,
      // og der kan ikke opstå uenighed mellem de to tal.

      const priserAf = (satser) => {
        const p = satser.map((x) => Number(x.price));
        return { lav: Math.min.apply(null, p), hoej: Math.max.apply(null, p) };
      };

      const prisTekst = (satser) => {
        const { lav, hoej } = priserAf(satser);
        if (hoej === 0) return 'Gratis';
        // «Fra …» KUN når fragtmændene faktisk koster forskelligt. Ellers er
        // «fra» et løfte om et billigere valg, der ikke findes.
        return lav === hoej ? kr(lav) : 'Fra ' + kr(lav);
      };

      const fragtmaendI = (satser) =>
        FRAGTMAEND.filter((f) => satser.some((x) => f.proev.test(String(x.name || x.presentment_name || ''))));

      // «DAO, GLS eller PostNord» — dansk opremsning, ikke en kommaliste.
      const opremsning = (navne) =>
        navne.length < 2 ? (navne[0] || '') : navne.slice(0, -1).join(', ') + ' eller ' + navne[navne.length - 1];

      const oversigt = (viste) => {
        const flere = viste.some((b) => fragtmaendI(b.satser).length > 1);
        const raekker = viste
          .map((b, i) => {
            const fm = fragtmaendI(b.satser);
            const tid = [...new Set(b.satser.map(dage))];
            const kanFoldes = b.satser.length > 1;
            return (
              '<li>' +
              '<' + (kanFoldes ? 'button type="button" data-mw-deliv-open="' + i + '"' : 'div') +
              ' class="mw-delivp__valg' + (kanFoldes ? ' mw-delivp__valg--klik' : '') + '">' +
              '<span class="mw-delivp__valgnavn">' + ren(b.titel) + '</span>' +
              '<span class="mw-delivp__valgpris mw-num' + (priserAf(b.satser).hoej === 0 ? ' is-free' : '') + '">' +
              prisTekst(b.satser) + '</span>' +
              (fm.length ? '<span class="mw-delivp__valgfm">' + ren(opremsning(fm.map((f) => f.navn))) + '</span>' : '') +
              (tid.length === 1 && tid[0] ? '<span class="mw-delivp__valgnote">' + ren(tid[0]) + '</span>' : '') +
              (kanFoldes ? '<span class="mw-delivp__chev" aria-hidden="true">›</span>' : '') +
              '</' + (kanFoldes ? 'button' : 'div') + '>' +
              '</li>'
            );
          })
          .join('');

        return (
          '<ul class="mw-delivp__rates" role="list">' + raekker + '</ul>' +
          '<p class="mw-delivp__note">Priser til <strong>' + ren(sted) + '</strong>.' +
          (flere ? ' Tryk for at se hver fragtmand.' : '') +
          (GRAENSE > 0 ? ' Over ' + GRAENSE + ' kr er fragten fri.' : '') +
          '</p>'
        );
      };

      const detalje = (b) => {
        const raekker = b.satser
          .slice()
          .sort((a, c) => Number(a.price) - Number(c.price))
          .map((sa) => {
            const navn = String(sa.name || sa.presentment_name || '');
            const f = FRAGTMAEND.find((x) => x.proev.test(navn));
            // Fragtmandens navn alene — gruppeordet står allerede i
            // overskriften, og «DAO DAO Pakkeshop» siger det tre gange.
            const vist = f ? f.navn : navn;
            const gratis = Number(sa.price) === 0;
            const t = dage(sa);
            return (
              '<li class="mw-delivp__fm">' +
              '<span class="mw-delivp__fmnavn">' + ren(vist) + '</span>' +
              '<span class="mw-delivp__fmpris mw-num' + (gratis ? ' is-free' : '') + '">' +
              (gratis ? 'Gratis' : kr(sa.price)) + '</span>' +
              (t ? '<span class="mw-delivp__fmnote">' + ren(t) + '</span>' : '') +
              (f ? '<span class="mw-delivp__fmlogo">' + maerke(f) + '</span>' : '') +
              '</li>'
            );
          })
          .join('');

        return (
          '<p class="mw-delivp__detaljetekst">' +
          (b.titel === 'Pakkeshop'
            ? 'Du henter selv pakken i en shop tæt på dig. Du vælger hvilken ved kassen.'
            : 'Pakken bringes til din adresse. Du vælger fragtmand ved kassen.') +
          '</p>' +
          '<ul class="mw-delivp__fmliste" role="list">' + raekker + '</ul>' +
          '<p class="mw-delivp__note">Priser til <strong>' + ren(sted) + '</strong>. Endelig pris bekræftes ved kassen.</p>'
        );
      };

      const viste = bunker.filter((b) => b.satser.length);

      // Visningen skiftes uden at hente igen. Fokus følger med, så en
      // tastaturbruger ikke bliver efterladt et sted, der ikke findes mere.
      const visOversigt = () => {
        ud.innerHTML = oversigt(viste);
        if (tilbage) tilbage.hidden = true;
        if (overskrift) overskrift.textContent = 'Levering og fragt';
      };

      const visDetalje = (i) => {
        const b = viste[i];
        if (!b) return;
        ud.innerHTML = detalje(b);
        if (overskrift) overskrift.textContent = b.titel;
        if (tilbage) {
          tilbage.hidden = false;
          tilbage.focus({ preventScroll: true });
        }
      };

      ud.__mwVisOversigt = visOversigt;
      ud.__mwVisDetalje = visDetalje;
      visOversigt();
    };

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-mw-deliv-form]');
      if (!form) return;
      e.preventDefault();

      const zip = form.querySelector('[data-mw-deliv-zip]');
      const ud = form.parentElement.querySelector('[data-mw-deliv-result]');
      const knap = form.querySelector('[type="submit"]');
      const panel = form.closest('.mw-delivp') || document;
      const tilbage = panel.querySelector('[data-mw-deliv-back]');
      const overskrift = panel.querySelector('[data-mw-deliv-heading]');
      if (!zip || !ud) return;

      const post = (zip.value || '').trim();
      if (!/^\d{4}$/.test(post)) {
        ud.innerHTML = '<p class="mw-delivp__note">Skriv et dansk postnummer på fire cifre.</p>';
        zip.focus();
        return;
      }

      knap.setAttribute('aria-busy', 'true');
      ud.innerHTML = '<p class="mw-delivp__note">Henter priser …</p>';
      const seq = ++delivSeq;
      delivAc?.abort();
      delivAc = new AbortController();
      const signal = delivAc.signal;

      try {
        const u = new URL('/cart/shipping_rates.json', window.location.origin);
        u.searchParams.set('shipping_address[zip]', post);
        u.searchParams.set('shipping_address[country]', 'Denmark');
        const r = await fetch(u, { headers: { Accept: 'application/json' }, signal });
        if (seq !== delivSeq) return;

        // 422 betyder som regel tom kurv: Shopify kan ikke beregne fragt for
        // ingenting. Det er ikke en fejl, det er en forudsætning.
        if (!r.ok) {
          ud.innerHTML = '<p class="mw-delivp__note">Læg en vare i kurven, så kan vi regne fragten ud for dig.</p>';
          return;
        }

        const data = await r.json();
        if (seq !== delivSeq) return;
        const satser = (data && data.shipping_rates) || [];
        if (!satser.length) {
          // En tom liste betyder to vidt forskellige ting, og Shopify svarer
          // 200 på dem begge: enten er kurven tom, eller også kom der ingen
          // priser retur. Kun 422 blev fanget ovenfor — den tomme kurv falder
          // hertil, og kunden fik at vide, at vi ikke leverer til hende.
          //
          // Fragtprofilen dækker hele Danmark. Der findes derfor ikke et
          // gyldigt dansk postnummer, vi ikke leverer til — så den sætning
          // kunne aldrig være sand, og den koster et salg hver gang.
          let tom = true;
          try {
            const c = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal });
            if (seq !== delivSeq) return;
            if (c.ok) tom = (((await c.json()) || {}).item_count || 0) === 0;
          } catch (e) {
            if (e.name === 'AbortError') throw e;
            /* kan ikke afgøres — sig da hellere for lidt end for meget */
          }
          if (seq !== delivSeq) return;
          ud.innerHTML = tom
            ? '<p class="mw-delivp__note">Læg en vare i kurven, så regner vi fragten ud for ' + post + '.</p>'
            : '<p class="mw-delivp__note">Vi kunne ikke hente priser for ' + post + ' lige nu. Skriv til os, så finder vi en løsning.</p>';
          return;
        }

        // BYNAVNET — bare fordi vi kan. DAWA er Danmarks officielle
        // adresse-API: offentligt, gratis, ingen nøgle, ingen sporing. Det
        // kaldes KUN når kunden selv trykker Beregn, og det er ren pynt:
        // svarer det ikke, står der bare postnummeret som før. Ingen await
        // på hovedsporet — priserne må aldrig vente på et bynavn.
        let sted = post;
        try {
          const by = await fetch('https://api.dataforsyningen.dk/postnumre/' + post, { signal: AbortSignal.timeout(2000) });
          if (seq !== delivSeq || signal.aborted) return;
          if (by.ok) {
            const j = await by.json();
            if (j && j.navn) sted = post + ' ' + j.navn;
          }
        } catch (e) {
          if (signal.aborted) return;
          // Bynavnet er en gave, ikke et krav (timeout/netværk).
        }
        if (seq !== delivSeq) return;

        // GRUPPERING. Med én fragtmand var en flad liste fin. Med tre fragtmænd
        // gange to leveringsformer bliver den seks lange, og så skal kunden
        // læse hver linje for at finde de to valg der reelt findes: hente selv,
        // eller få det bragt. Samme greb som Matas: gruppér på leveringsform,
        // lad fragtmanden være detaljen indeni.
        //
        // Navnet er eneste signal Shopify giver os (carrier_identifier er null
        // på manuelle satser), så vi matcher på ord — ikke på præcis streng.
        // Omdøbes en sats i admin til "GLS pakkeshop u/omdeling", virker den
        // stadig. Passer en sats i ingen gruppe, ryger den i "Andre
        // muligheder" — den forsvinder aldrig.
        tegn(ud, satser, sted, panel);
      } catch (err) {
        if (err.name === 'AbortError' || seq !== delivSeq) return;
        ud.innerHTML = '<p class="mw-delivp__note">Kunne ikke hente priser lige nu. Prøv igen om et øjeblik.</p>';
      } finally {
        if (seq === delivSeq) knap.removeAttribute('aria-busy');
      }
    });

    // Panelet svarede først, når kunden havde gjort noget først — og det,
    // den så svarede, var det samme for alle. Nu står prisen der, når
    // panelet åbner. Trykker kunden Beregn OG har en kurv, erstattes den af
    // Shopifys rigtige satser, som også kender fri fragt-grænsen og rabatter.
    const husTegn = () => {
      document.querySelectorAll('[data-mw-deliv-result]').forEach((ud) => {
        if (ud.innerHTML.trim()) return;
        let hus = [];
        try { hus = JSON.parse(ud.getAttribute('data-mw-hussatser') || '[]'); } catch (e) { return; }
        if (!hus.length) return;
        tegn(ud, hus, 'hele Danmark', ud.closest('.mw-delivp') || document);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', husTegn); else husTegn();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-drawer')) return;

    // Én fælles scroll-lås: flere drawers må aldrig kæmpe om body-stilen.
    const lock = {
      depth: 0,
      y: 0,
      on() {
        if (this.depth++ > 0) return;
        this.y = window.scrollY;
        const b = document.body.style;
        b.position = 'fixed';
        b.insetInline = '0';
        b.top = `-${this.y}px`;
        b.width = '100%';
      },
      off() {
        if (this.depth <= 0) return;
        this.depth -= 1;
        if (this.depth > 0) return;
        const b = document.body.style;
        b.position = '';
        b.insetInline = '';
        b.top = '';
        b.width = '';
        window.scrollTo(0, this.y);
      },
    };

    class MwDrawer extends HTMLElement {
      #trigger = null;
      #closing = false;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.dialog.addEventListener('click', (e) => {
          if (e.target.closest('[data-mw-drawer-close]')) {
            this.close();
            return;
          }
          // Klik på selve dialogen = backdrop (panelet fanger sine egne klik)
          if (e.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        // Robust fallback: nogle WebViews og automatiserede tastaturflows
        // sender ikke dialogens native `cancel` videre fra et fokuseret felt.
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          e.preventDefault();
          this.close();
        });
      }

      open(trigger) {
        if (!this.dialog || this.dialog.open) return;
        this.#closing = false;
        this.#trigger = trigger || document.activeElement;
        this.dialog.showModal();
        lock.on();
        // Tvungen reflow frem for rAF (fyrer ikke i baggrundsfaner), så
        // transitionen starter fra den lukkede tilstand.
        void this.dialog.offsetWidth;
        this.dialog.classList.add('is-open');
        const first = this.dialog.querySelector('[data-mw-drawer-autofocus], [data-mw-drawer-close]');
        if (first) first.focus();
        this.dispatchEvent(new CustomEvent('mw:drawer:open', { bubbles: true }));
      }

      close() {
        if (!this.dialog || !this.dialog.open || this.#closing) return;
        this.#closing = true;
        const finish = () => {
          if (!this.dialog.open) {
            this.#closing = false;
            lock.off();
            return;
          }
          this.dialog.close();
          this.#closing = false;
          lock.off();
          if (this.#trigger && document.contains(this.#trigger)) this.#trigger.focus();
          this.#trigger = null;
          this.dispatchEvent(new CustomEvent('mw:drawer:close', { bubbles: true }));
        };

        if (this.reduced.matches) {
          this.dialog.classList.remove('is-open');
          finish();
          return;
        }

        // transitionend kan udeblive (baggrundsfane, afbrudt transition) —
        // fallback garanterer at panelet altid lukker.
        let fallback;
        const done = (e) => {
          if (e && e.target !== this.dialog.querySelector('.mw-drawer__panel')) return;
          clearTimeout(fallback);
          this.dialog.removeEventListener('transitionend', done);
          finish();
        };
        this.dialog.addEventListener('transitionend', done);
        fallback = setTimeout(done, 600);
        this.dialog.classList.remove('is-open');
      }

      toggle(trigger) {
        if (this.dialog && this.dialog.open) this.close();
        else this.open(trigger);
      }
    }

    customElements.define('mw-drawer', MwDrawer);
    // Én ejer af body-scroll-låsen (MW-013): cart-draweren genbruger den i
    // stedet for at have sin egen iOS-lås. Dybdetælleren gør sekventielle/
    // nestede åbninger sikre.
    window.mwScrollLock = lock;

    // Deklarativ åbning: nye forbrugere kræver ingen JS.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mw-drawer-open]');
      if (!btn) return;
      const target = document.getElementById(btn.getAttribute('data-mw-drawer-open'));
      if (!target || typeof target.open !== 'function') return;
      e.preventDefault();
      target.open(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-motion"] && !Shopify.designMode) return;
  try {
    // Ambient-video-controller (MW-034): spil kun synlige videoer, aldrig under
  // reduced motion; knappen giver brugeren stop/start (WCAG 2.2.2).
  (() => {
    if (window.__mwAmbient) return;
    window.__mwAmbient = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const state = new WeakMap(); // container → { visible, userPaused, seq }
    // Sekvens (kontrakt: maks. én tydelig bevægelse pr. viewport): videoer inde i
    // [data-mw-ambient-sequence] afspilles én ad gangen, i rækkefølge, i loop.
    const sequences = new WeakMap(); // seq-element → { boxes: [], i: 0 }

    const seqCurrent = (box) => {
      const st = state.get(box);
      const seq = st && st.seq ? sequences.get(st.seq) : null;
      if (!seq) return true;
      const visibleBoxes = seq.boxes.filter((b) => state.get(b).visible && !state.get(b).userPaused);
      if (!visibleBoxes.length) return false;
      // Hold index inden for de synlige
      const cur = seq.boxes[seq.i];
      const active = visibleBoxes.includes(cur) ? cur : visibleBoxes[0];
      return active === box;
    };

    const render = (box) => {
      const st = state.get(box);
      const video = box.querySelector('video');
      const btn = box.querySelector('[data-mw-ambient-toggle]');
      if (!video || !st) return;
      const shouldPlay = st.visible && !st.userPaused && !reduced.matches && seqCurrent(box);
      // Bytes hentes først, når videoen nærmer sig viewporten (preload='none' i markup)
      if (shouldPlay && video.preload !== 'auto') video.preload = 'auto';
      if (shouldPlay) video.play().catch(() => {});
      else video.pause();
      if (btn) {
        btn.hidden = reduced.matches; // ingen kontrol der lover bevægelse
        const base = (btn.getAttribute('aria-label') || '').replace(/^(Sæt |Afspil )/, '').replace(/ på pause$/, '');
        btn.setAttribute('aria-label', st.userPaused ? 'Afspil ' + base : 'Sæt ' + base + ' på pause');
        btn.querySelector('[data-mw-ambient-icon="pause"]').hidden = st.userPaused;
        btn.querySelector('[data-mw-ambient-icon="play"]').hidden = !st.userPaused;
      }
    };

    const io = new IntersectionObserver((entries) => {
      const seqsTouched = new Set();
      for (const e of entries) {
        const st = state.get(e.target);
        if (!st) continue;
        st.visible = e.isIntersecting && e.intersectionRatio >= 0.25;
        if (st.seq) seqsTouched.add(st.seq); else render(e.target);
      }
      // I en sekvens afhænger "hvem spiller" af alle → render hele gruppen
      seqsTouched.forEach((seqEl) => sequences.get(seqEl)?.boxes.forEach(render));
    }, { threshold: [0, 0.25], rootMargin: '200px 0px' });

    const attach = (box) => {
      if (state.has(box)) return;
      const seqEl = box.closest('[data-mw-ambient-sequence]');
      state.set(box, { visible: false, userPaused: false, seq: seqEl });
      if (seqEl) {
        if (!sequences.has(seqEl)) sequences.set(seqEl, { boxes: [], i: 0 });
        const seq = sequences.get(seqEl);
        seq.boxes.push(box);
        const video = box.querySelector('video');
        if (video) {
          video.loop = false;
          video.addEventListener('ended', () => {
            // Næste synlige i rækken — wrap rundt
            const n = seq.boxes.length;
            let k = (seq.boxes.indexOf(box) + 1) % n;
            for (let tries = 0; tries < n; tries++) { const b = seq.boxes[k]; const s2 = state.get(b); if (s2 && s2.visible && !s2.userPaused) break; k = (k + 1) % n; }
            seq.i = k;
            try { seq.boxes[k].querySelector('video').currentTime = 0; } catch (e) { /* ikke indlæst endnu */ }
            seq.boxes.forEach(render);
          });
        }
      }
      box.querySelector('[data-mw-ambient-toggle]')?.addEventListener('click', () => {
        const st = state.get(box);
        st.userPaused = !st.userPaused;
        render(box);
      });
      io.observe(box);
      render(box);
    };

    const scan = () => document.querySelectorAll('[data-mw-ambient]').forEach(attach);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
    reduced.addEventListener('change', () => document.querySelectorAll('[data-mw-ambient]').forEach(render));
  })();

  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.__mwMotion) return;
    window.__mwMotion = true;

    // Kan browseren scroll-tidslinjer, kører motoren i CSS på compositoren, og
    // dette lag har intet at lave. Vi lader være med at armere: ingen observer,
    // ingen klasser, ingen arbejde på hovedtråden. Reserven herunder er kun for
    // browsere, der mangler animation-timeline.
    if (CSS.supports('animation-timeline', 'view()')) return;

    let ioAlive = false;
    let failsafe = 0;
    const io = new IntersectionObserver(
      (entries) => {
        ioAlive = true;
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('mw-rv--in');
            io.unobserve(e.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    const arm = () => {
      const targets = [];
      document.querySelectorAll('[data-mw-reveal]').forEach((el) => targets.push([el, 0]));
      document.querySelectorAll('[data-mw-stagger]').forEach((c) => {
        Array.from(c.children).forEach((el, i) => targets.push([el, i % 6]));
      });
      const vh = window.innerHeight || document.documentElement.clientHeight || 800;
      const vw = window.innerWidth || document.documentElement.clientWidth || 1200;
      for (const [el, i] of targets) {
        if (el.classList.contains('mw-rv') || el.classList.contains('mw-rv--in')) continue;
        const r = el.getBoundingClientRect();
        const inViewNow = r.top < vh * 0.92 && r.left < vw && r.bottom > 0;
        if (inViewNow) continue;
        el.style.setProperty('--mw-i', i);
        el.classList.add('mw-rv');
        io.observe(el);
      }
      if (!failsafe && document.querySelector('.mw-rv')) {
        failsafe = setTimeout(() => {
          if (!ioAlive) {
            document.querySelectorAll('.mw-rv').forEach((el) => el.classList.add('mw-rv--in'));
            io.disconnect();
          }
        }, 2500);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arm);
    } else {
      arm();
    }
    document.addEventListener('shopify:section:load', arm);
    document.addEventListener('mw:collection:updated', arm);
  })();

  // LYSSTREJF på produktkort (MW: gradient/glød-laget). Én delegeret lytter
  // frem for én pr. kort — der står op til 24 kort på en kollektionsside.
  //
  // Positionen skrives i en requestAnimationFrame: pointermove kan fyre
  // hundredvis af gange i sekundet, og hvert kald ville ellers tvinge et
  // layout-opslag. Nu bliver det højst ét pr. billede.
  (() => {
    if (window.__mwSheen) return;
    window.__mwSheen = true;
    // Ingen markør at følge på en berøringsskærm, og under reduceret
    // bevægelse hører effekten slet ikke hjemme.
    if (!matchMedia('(hover: hover)').matches) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let sidste = null;
    let planlagt = false;
    document.addEventListener('pointermove', (e) => {
      const kort = e.target.closest && e.target.closest('.mw-pcard[data-mw-sheen]');
      if (!kort) return;
      const flade = kort.querySelector('.mw-pcard__media');
      if (!flade) return;
      sidste = { flade, x: e.clientX, y: e.clientY };
      if (planlagt) return;
      planlagt = true;
      requestAnimationFrame(() => {
        planlagt = false;
        if (!sidste) return;
        const r = sidste.flade.getBoundingClientRect();
        if (!r.width || !r.height) return;
        sidste.flade.style.setProperty('--mx', (((sidste.x - r.left) / r.width) * 100).toFixed(1) + '%');
        sidste.flade.style.setProperty('--my', (((sidste.y - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-quick-add"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-quick-add')) return;
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Arver drawer-mekanikken (mw-drawer) og tilføjer hentning + variant-opløsning.
    // Defineres først når mw-drawer findes (bundle-rækkefølge er ikke garanteret).
    const define = () => {
    const Base = customElements.get('mw-drawer');

    class MwQuickAdd extends Base {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        this.content = this.querySelector('[data-mw-qad-content]');
        this.loading = this.querySelector('[data-mw-qad-loading]');
        this._qac = new AbortController();
        const sig = { signal: this._qac.signal };

        document.addEventListener('click', (e) => {
          const t = e.target.closest('[data-mw-quick-add]');
          if (!t) return;
          e.preventDefault();
          this.load(t.getAttribute('data-mw-quick-add'), t);
        }, sig);

        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-mw-qa-option]')) this.#resolve();
        }, sig);

        // Når draweren opsnapper formen, lukker vi panelet så kurven kan åbne
        this.addEventListener('submit', () => setTimeout(() => this.close(), 0), sig);
      }

      disconnectedCallback() {
        if (super.disconnectedCallback) super.disconnectedCallback();
        this._qac?.abort();
        this._loadReq?.abort();
      }

      async load(handle, trigger) {
        if (!handle) return;
        this._loadReq?.abort();
        this._loadReq = new AbortController();
        const loadSig = this._loadReq.signal;
        this.content.setAttribute('aria-busy', 'true');
        this.content.querySelector('[data-mw-qa-root]')?.remove();
        this.loading.hidden = false;
        // Aldrig to modaler oven på hinanden: luk kurven, før panelet åbner
        // (kurven åbner igen efter tilføjelse via form-intercept).
        document.querySelector('mw-cart-drawer')?.close();
        this.open(trigger);
        try {
          const res = await fetch(root() + 'products/' + encodeURIComponent(handle) + '?section_id=mw-quick-add', { signal: loadSig, headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error('http ' + res.status);
          const html = await res.text();
          if (loadSig.aborted) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const panel = doc.querySelector('[data-mw-qa-root]');
          if (!panel) throw new Error('no panel');
          this.content.appendChild(panel);
          this.#resolve();
          // Fokus på panelets titel (tilgængeligt navn), ikke en skjult radio
          const title = panel.querySelector('#MwQuickAddTitle');
          if (title) { title.setAttribute('tabindex', '-1'); title.focus(); }
        } catch (err) {
          if (err.name === 'AbortError') return;
          // Fald tilbage til PDP — aldrig en død skal
          if (trigger && trigger.href) window.location.assign(trigger.href);
        } finally {
          if (loadSig.aborted) return;
          this.loading.hidden = true;
          this.content.setAttribute('aria-busy', 'false');
        }
      }

      #resolve() {
        const rootEl = this.content.querySelector('[data-mw-qa-root]');
        if (!rootEl) return;
        let variants = [];
        try { variants = JSON.parse(rootEl.querySelector('[data-mw-qa-variants]').textContent); } catch (err) { variants = []; }
        const groups = Array.from(rootEl.querySelectorAll('fieldset'));
        const chosen = groups.map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
        groups.forEach((g, gi) => { const l = g.querySelector('[data-mw-qa-chosen]'); if (l) l.textContent = window.mwOptionLabel ? window.mwOptionLabel(chosen[gi] || '') : (chosen[gi] || ''); });
        const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        // Markér utilgængelige valg pr. gruppe givet øvrige valg
        groups.forEach((g, gi) => {
          g.querySelectorAll('input[type="radio"]').forEach((inp) => {
            const probe = chosen.slice(); probe[gi] = inp.value;
            const ok = variants.some((v) => v.available && v.options.every((o, i) => probe[i] === null || o === probe[i]));
            inp.nextElementSibling?.classList.toggle('is-unavailable', !ok);
          });
        });
        const idEl = rootEl.querySelector('[data-mw-qa-id]');
        const atc = rootEl.querySelector('[data-mw-qa-atc]');
        const price = rootEl.querySelector('[data-mw-qa-price]');
        const flag = rootEl.querySelector('[data-mw-qa-flag]');
        if (match) {
          idEl.value = match.id;
          atc.disabled = !match.available;
          atc.textContent = match.available
            ? (rootEl.dataset.preorder === 'true' ? 'Forudbestil' : 'Læg i kurv')
            : 'Udsolgt';
          if (flag) {
            if (!match.available) {
              flag.textContent = 'Udsolgt';
              flag.hidden = false;
            } else if (rootEl.dataset.preorder === 'true') {
              flag.textContent = 'Forudbestilling';
              flag.hidden = false;
            } else {
              flag.hidden = true;
            }
          }
          if (price && window.Shopify && typeof match.price === 'number') price.textContent = this.#money(match.price);
          // Variantens eget billede (én sandhed: PDP, quick-add, kurv)
          const img = rootEl.querySelector('[data-mw-qa-img]');
          const src = match.featured_image && match.featured_image.src;
          if (img && src && img.dataset.mwSrc !== src) {
            img.dataset.mwSrc = src;
            img.removeAttribute('srcset');
            img.src = src + (src.includes('?') ? '&' : '?') + 'width=300';
          }
        } else {
          atc.disabled = true;
          atc.textContent = 'Vælg kombination';
          if (flag) flag.hidden = true;
        }
      }

      // Kun til targeted opdatering af prisen (DK-only-antagelse, jf. katalog §1.1)
      #money(cents) {
        if (window.mwMoney) return window.mwMoney(cents);
        const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
        try { return new Intl.NumberFormat('da-DK', { style: 'currency', currency: fmt }).format(cents / 100).replace(/ /g, ' '); }
        catch (err) { return (cents / 100).toFixed(2).replace('.', ',') + ' kr.'; }
      }
    }

    customElements.define('mw-quick-add', MwQuickAdd);
    };
    if (customElements.get('mw-drawer')) define();
    else customElements.whenDefined('mw-drawer').then(define);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-search"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-search')) return;

    class MwSearch extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('[data-mw-search-input]');
        this.results = this.querySelector('[data-mw-search-results]');
        this.hint = this.querySelector('[data-mw-search-hint]');
        this.live = this.querySelector('[data-mw-search-live]');
        if (!this.dialog || !this.input) return;
        this._ac = new AbortController();
        const sig = { signal: this._ac.signal };
        this._deb = 0;
        this._req = null;

        document.addEventListener('click', (e) => {
          const t = e.target.closest('[data-mw-search-open]');
          if (!t) return;
          e.preventDefault();
          this.open(t);
        }, sig);
        // Tastaturgenvej: ⌘/Ctrl+K åbner søgning (WCAG 2.1.4: ingen enkelt-tast-genvej uden modifier)
        document.addEventListener('keydown', (e) => {
          if ((e.metaKey || e.ctrlKey) && !e.altKey && (e.key === 'k' || e.key === 'K')) {
            e.preventDefault();
            this.open(document.activeElement);
          }
        }, sig);

        this.querySelector('[data-mw-search-close]')?.addEventListener('click', () => this.close(), sig);
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); }, sig);
        this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); }, sig);
        // Fallback til WebViews og syntetiske tastatur-events, hvor dialogens
        // native `cancel` ikke altid bliver sendt videre fra søgefeltet.
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          e.preventDefault();
          this.close();
        }, sig);

        this.input.addEventListener('input', () => {
          clearTimeout(this._deb);
          this._deb = setTimeout(() => this.search(this.input.value.trim()), 200);
        }, sig);
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            const first = this.results.querySelector('[data-mw-ps-link], a');
            if (first) { e.preventDefault(); first.focus(); }
          }
        }, sig);
        this.results.addEventListener('keydown', (e) => {
          const links = Array.from(this.results.querySelectorAll('[data-mw-ps-link], a'));
          const i = links.indexOf(document.activeElement);
          if (i < 0) return;
          if (e.key === 'ArrowDown') { e.preventDefault(); (links[i + 1] || links[0]).focus(); }
          if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) this.input.focus(); else links[i - 1].focus(); }
        }, sig);
      }

      disconnectedCallback() { this._ac?.abort(); this._req?.abort(); clearTimeout(this._deb); }

      open(trigger) {
        if (this.dialog.open) return;
        this._closing = false;
        this._trigger = trigger && trigger.focus ? trigger : document.activeElement;
        document.querySelector('mw-cart-drawer')?.close();
        this.dialog.showModal();
        window.mwScrollLock?.on();
        void this.dialog.offsetWidth;
        this.dialog.classList.add('is-open');
        this.input?.setAttribute('aria-expanded', 'true');
        this.input?.focus();
      }

      close() {
        if (!this.dialog?.open || this._closing) return;
        this._closing = true;
        clearTimeout(this._deb);
        this._req?.abort();
        this.input?.setAttribute('aria-expanded', 'false');
        const finish = () => {
          if (!this.dialog?.open) {
            this._closing = false;
            window.mwScrollLock?.off();
            return;
          }
          this.dialog.close();
          this._closing = false;
          window.mwScrollLock?.off();
          if (this._trigger && document.contains(this._trigger)) this._trigger.focus();
          this._trigger = null;
        };
        let fb;
        const done = (e) => { if (e && e.target !== this.dialog?.querySelector('.mw-search__panel')) return; clearTimeout(fb); this.dialog?.removeEventListener('transitionend', done); finish(); };
        this.dialog.addEventListener('transitionend', done);
        fb = setTimeout(done, 400);
        this.dialog.classList.remove('is-open');
      }

      async search(q) {
        this._req?.abort();
        if (q.length < 2) {
          this.results?.replaceChildren(this.hint);
          this.input?.setAttribute('aria-expanded', 'true');
          this.results?.setAttribute('aria-busy', 'false');
          return;
        }
        this._req = new AbortController();
        const req = this._req;
        this.results?.setAttribute('aria-busy', 'true');
        try {
          const url = this.dataset.url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=4&resources[options][unavailable_products]=last&section_id=mw-predictive-search';
          const res = await fetch(url, { signal: req.signal, headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error('http ' + res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const root = doc.querySelector('[data-mw-ps-root]');
          if (!root) throw new Error('no root');
          this.results?.replaceChildren(root);
          this.input?.setAttribute('aria-expanded', 'true');

          const n = Number(root.dataset.count) || 0;
          if (this.live) this.live.textContent = n === 0 ? 'Ingen resultater' : n + (n === 1 ? ' resultat' : ' resultater') + ' — brug piletasterne';
        } catch (err) {
          if (err.name === 'AbortError') return;
          const p = document.createElement('p');
          p.className = 'mw-search__error';
          p.textContent = 'Søgningen svarer ikke lige nu — tryk Enter for at søge alligevel.';
          this.results?.replaceChildren(p);
          this.input?.setAttribute('aria-expanded', 'true');
        } finally {
          // Abortet request eller overhalet af nyere søgning: lad busy stå —
          // den aktive request ejer busy-flaget.
          if (req.signal.aborted || this._req !== req) return;
          this.results?.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('mw-search', MwSearch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-support-search"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-support-search')) return;

    const norm = (s) =>
      (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/æ/g, 'ae')
        .replace(/ø/g, 'oe');

    class MwSupportSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-mw-supp-input]');
        this.list = this.querySelector('[data-mw-supp-results]');
        this.live = this.querySelector('[data-mw-supp-live]');
        const raw = this.querySelector('[data-mw-supp-index]');
        if (!this.input || !this.list || !raw) return;
        this.uid = this.list.id;
        this._ac = new AbortController();
        const sig = { signal: this._ac.signal };
        try {
          this.index = JSON.parse(raw.textContent);
        } catch (e) {
          this.index = [];
        }
        this.index.forEach((a) => {
          a._t = norm(a.t);
          a._all = norm(a.t + ' ' + a.k + ' ' + a.s);
        });
        this.sel = -1;
        this._deb = 0;

        this.input.addEventListener('input', () => {
          clearTimeout(this._deb);
          this._deb = setTimeout(() => this.search(), 150);
        }, sig);
        this.input.addEventListener('keydown', (e) => this.onKey(e), sig);
        // Options er ikke fokusérbare (APG combobox): klik navigerer programmatisk
        this.list.addEventListener('click', (e) => {
          const opt = e.target.closest('[role="option"]');
          if (opt && opt.dataset.url) window.location.assign(opt.dataset.url);
        }, sig);
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.closeList();
        }, sig);
      }

      // Theme Editor re-render / dubletter (MW-038): ingen ophobede lyttere/timere
      disconnectedCallback() {
        clearTimeout(this._deb);
        this._ac?.abort();
      }

      search() {
        const q = norm(this.input.value.trim());
        if (q.length < 2) return this.closeList();
        const words = q.split(/\s+/);
        const scored = [];
        for (const a of this.index) {
          let score = 0;
          if (a._t.startsWith(q)) score += 8;
          for (const w of words) {
            if (a._t.includes(w)) score += 4;
            else if (a._all.includes(w)) score += 1;
          }
          if (score > 0) scored.push([score, a]);
        }
        scored.sort((x, y) => y[0] - x[0]);
        this.renderList(scored.slice(0, 7).map((x) => x[1]));
      }

      renderList(items) {
        this.list.textContent = '';
        this.sel = -1;
        if (!items.length) {
          const li = document.createElement('li');
          li.className = 'mw-supsearch__empty';
          li.textContent = 'Ingen resultater — prøv et andet ord, eller ';
          const a = document.createElement('a');
          a.href = this.dataset.contactUrl || '/pages/contact';
          a.textContent = 'kontakt os';
          li.append(a, document.createTextNode('.'));
          this.list.appendChild(li);
        } else {
          items.forEach((a, i) => {
            const li = document.createElement('li');
            li.className = 'mw-supsearch__opt';
            li.setAttribute('role', 'option');
            li.id = this.uid + '-opt-' + i;
            li.setAttribute('aria-selected', 'false');
            li.dataset.url = a.u;
            const meta = document.createElement('span');
            meta.className = 'mw-supsearch__opt-meta';
            meta.textContent = a.c;
            const title = document.createElement('span');
            title.className = 'mw-supsearch__opt-title';
            title.textContent = a.t;
            li.append(meta, title);
            this.list.appendChild(li);
          });
        }
        this.list.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        if (this.live) this.live.textContent = items.length + ' resultater';
      }

      onKey(e) {
        if (this.list.hidden) return;
        const opts = this.list.querySelectorAll('[role="option"]');
        if (e.key === 'Escape') {
          this.closeList();
          return;
        }
        if (e.key === 'Enter') {
          // Før krævede Enter, at man FØRST havde valgt med piletast. Skrev
          // man sit spørgsmål og trykkede Enter — den mest almindelige måde
          // at søge på — skete der ingenting. Nu lander tastetrykket altid:
          // på det valgte, ellers på det første træf, ellers på kontakt.
          e.preventDefault();
          const valgt = this.sel >= 0 ? opts[this.sel] : opts[0];
          window.location.assign(
            valgt && valgt.dataset.url ? valgt.dataset.url : (this.dataset.contactUrl || '/pages/contact')
          );
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        if (!opts.length) return;
        this.sel = e.key === 'ArrowDown' ? Math.min(this.sel + 1, opts.length - 1) : Math.max(this.sel - 1, 0);
        opts.forEach((o, i) => o.setAttribute('aria-selected', i === this.sel ? 'true' : 'false'));
        this.input.setAttribute('aria-activedescendant', opts[this.sel].id);
        opts[this.sel].scrollIntoView({ block: 'nearest' });
      }

      closeList() {
        this.list.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.sel = -1;
      }
    }

    customElements.define('mw-support-search', MwSupportSearch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-toast"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('mw-toast')) return;

    const VISIBLE_MS = 6000;
    // En kvittering må gerne glide væk — beskeden er «det virkede», og den
    // er allerede bekræftet af at kurven ændrer sig. En fejl skal læses,
    // forstås og handles på, og 6 sekunder er ikke nok til tre ting.
    const ERROR_MS = 12000;

    class MwToast extends HTMLElement {
      #timer = null;
      #closeFallback = null;
      #closeHandler = null;
      #paused = false;

      connectedCallback() {
        this.msg = this.querySelector('[data-mw-toast-msg]');
        this.actionBtn = this.querySelector('[data-mw-toast-action]');
        this.closeBtn = this.querySelector('[data-mw-toast-close]');
        if (!this.msg) return;

        this.closeBtn?.addEventListener('click', () => this.dismiss());

        // WCAG 2.2.1: nedtællingen holder pause så længe brugeren er i
        // kontakt med toasten, og starter forfra når kontakten slipper.
        this.addEventListener('pointerenter', () => this.#pause());
        this.addEventListener('pointerleave', () => this.#resume());
        this.addEventListener('focusin', () => this.#pause());
        this.addEventListener('focusout', () => this.#resume());

        window.mwToast = (message, options) => this.show(message, options);
      }

      show(message, options) {
        const opts = options || {};
        clearTimeout(this.#timer);
        // En igangværende dismiss må ikke skjule den nye toast (race < 400 ms)
        clearTimeout(this.#closeFallback);
        if (this.#closeHandler) { this.removeEventListener('transitionend', this.#closeHandler); this.#closeHandler = null; }
        this.#paused = false;

        // Live region skal være tom, når teksten skiftes — ellers springer
        // skærmlæsere en gentaget besked over.
        this.msg.textContent = '';
        this.hidden = false;
        const tone = opts.tone === 'error' || opts.tone === 'ok' ? opts.tone : 'info';
        this.dataset.tone = tone;
        this.msg.setAttribute('role', tone === 'error' ? 'alert' : 'status');
        this.msg.setAttribute('aria-live', tone === 'error' ? 'assertive' : 'polite');

        const action = opts.action;
        if (action && action.label) {
          this.actionBtn.textContent = action.label;
          this.actionBtn.hidden = false;
          this.actionBtn.onclick = () => {
            this.dismiss();
            if (typeof action.onClick === 'function') action.onClick();
          };
        } else {
          this.actionBtn.hidden = true;
          this.actionBtn.onclick = null;
        }

        // Tvungen reflow frem for requestAnimationFrame: rAF fyrer IKKE i en
        // baggrundsfane, og så ville toasten hverken blive synlig eller få
        // sin tekst. Reflow låser starttilstanden, så transitionen stadig
        // kører, og setTimeout(0) genstarter live region-annonceringen.
        void this.offsetWidth;
        this.classList.add('is-open');
        setTimeout(() => {
          this.msg.textContent = message;
        }, 0);

        this.#arm();
        return this;
      }

      dismiss() {
        clearTimeout(this.#timer);
        this.classList.remove('is-open');
        const done = () => {
          this.hidden = true;
          this.msg.textContent = '';
        };
        // Fallback hvis transitionen aldrig starter (skjult fane, reduced motion).
        clearTimeout(this.#closeFallback);
        if (this.#closeHandler) this.removeEventListener('transitionend', this.#closeHandler);
        this.#closeFallback = setTimeout(() => { this.#closeHandler = null; done(); }, 400);
        this.#closeHandler = (e) => {
          if (e.target !== this.querySelector('.mw-toast__inner')) return;
          clearTimeout(this.#closeFallback);
          this.removeEventListener('transitionend', this.#closeHandler);
          this.#closeHandler = null;
          done();
        };
        this.addEventListener('transitionend', this.#closeHandler);
      }

      #arm() {
        clearTimeout(this.#timer);
        if (this.#paused) return;
        const ms = this.dataset.tone === 'error' ? ERROR_MS : VISIBLE_MS;
        this.#timer = setTimeout(() => this.dismiss(), ms);
      }

      #pause() {
        this.#paused = true;
        clearTimeout(this.#timer);
      }

      #resume() {
        this.#paused = false;
        this.#arm();
      }
    }

    customElements.define('mw-toast', MwToast);
  })();
  } catch(e) { console.error(e); }
})();

})();
